import startCase from "lodash/startCase";
import toLower from "lodash/toLower";

export const toTitleCase = (sentence: string): string => {
  if (!sentence) return "";
  return startCase(toLower(sentence));
};
